module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio-box",
    class: {
      'disabled': _vm.disabled
    },
    on: {
      "click": _vm.change
    }
  }, [_c('div', {
    staticClass: "content",
    class: {
      active: _vm.val,
      'disabled': _vm.disabled
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc8d1a0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/Form/RadioBox.vue
// module id = 1179
// module chunks = 0